import Table from "@/common/components/Table";
import { useFilterParams } from "@/common/hooks/useFilterParams";
import { PaymentModalityType } from "@/features/companies/types/companies.type";
import { companyGovernmentAllocationColumns } from "@/features/privateCompanies/constants/companyGovernmentAllocationColumns.constant";
import { CompanyGovernmentAllocationTransformer } from "@/features/privateCompanies/services/companyGovernmentAllocationsTransformer";
import { CompanyGovernmentAllocationData } from "@/features/privateCompanies/types/companyGovernmentAllocation.type";
import { useEffect, useRef } from "react";

interface GovernmentAllocationTimelineViewProps {
  companyGovernmentAllocations: CompanyGovernmentAllocationData[];
  companyGovernmentAllocationsIsPending: boolean;
  companyPaymentModality?: PaymentModalityType;
  isPending?: boolean
  hasNextPage?: boolean
  isFetchingNextPage?: boolean
  fetchNextPage?: () => void
}

const GovernmentAllocationTimelineView = ({
  companyGovernmentAllocationsIsPending,
  companyPaymentModality,
  companyGovernmentAllocations,
  isPending,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage
}: GovernmentAllocationTimelineViewProps) => {
  const { filterParams } = useFilterParams();
  const scrollContainerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current
    if (!scrollContainer || !fetchNextPage) return

    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } = scrollContainer

      if (scrollHeight - scrollTop <= clientHeight + 50) {
        if (hasNextPage && !isFetchingNextPage && !isPending) {
          fetchNextPage()
        }
      }
    }

    scrollContainer.addEventListener('scroll', handleScroll)
    return () => scrollContainer.removeEventListener('scroll', handleScroll)
  }, [hasNextPage, isFetchingNextPage, isPending, fetchNextPage])

  return (
    <Table
      className="max-h-[calc(100vh-264px)] shadow-[0px_0px_8px_4px_rgba(0,_0,_0,_0.2)]"
      headerCellClassName="min-w-[60px]"
      isLoadingData={companyGovernmentAllocationsIsPending}
      columns={companyGovernmentAllocationColumns(companyPaymentModality)}
      rows={CompanyGovernmentAllocationTransformer.timelineTransformer({
        companyGovernmentAllocations,
        year: filterParams.year || new Date().getFullYear(),
        companyPaymentModality,
      })()}
      page={1}
      rowEmptyValue=""
      totalPages={1}
      ref={scrollContainerRef}
    />
  );
};

export default GovernmentAllocationTimelineView;
